import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  JustifyContent,
  Space,
  ZIndex,
} from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { boxSummaryVisibilityChange } from 'actions/boxSummary'
import * as trackingKeys from 'actions/trackingKeys'
import type { View } from 'utils/view'

import { BasketComprehensionSummary } from '../BasketComprehensionSummary'
import { CheckoutButton } from '../CheckoutButton'
import { VisualBasket } from '../VisualBasket'

type Props = {
  view: View
}

export const BasketComprehensionBanner = ({ view }: Props) => {
  const dispatch = useDispatch()

  const openOrderSummary = (event: React.MouseEvent<HTMLElement>) => {
    // Focus the bar so the modal restores focus here on close, not to a stale
    // off-screen element (which would scroll the page to the bottom).
    event.currentTarget.focus({ preventScroll: true })
    dispatch(boxSummaryVisibilityChange(true))
  }

  return (
    <section>
      <Box
        data-testid="basket-comprehension-banner"
        tabIndex={-1}
        alignItems={[AlignItems.Stretch, null, AlignItems.Center]}
        bg={Color.ColdGrey_800}
        bottom="0"
        boxShadow="0px -4px 8px rgba(0, 0, 0, 0.16)"
        onClick={openOrderSummary}
        style={{ cursor: 'pointer', outline: 'none' }}
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, null, FlexDirection.Row]}
        left="0"
        height={['146px', '88px', '88px']}
        paddingH={[3, null, 10]}
        paddingV={[2, null, 0]}
        position={DisplayPosition.Fixed}
        width="100%"
        zIndex={ZIndex.Toast}
      >
        <VisualBasket />

        <Box
          alignItems={AlignItems.Center}
          display={Display.Flex}
          flexGrow={1}
          height={['auto', null, '100%']}
          justifyContent={[JustifyContent.SpaceBetween, null, JustifyContent.FlexEnd]}
          width={['100%', null, 'auto']}
          data-no-code="boxSummaryPriceContainer"
        >
          <BasketComprehensionSummary />

          <Space direction="horizontal" size={4} />
          <CheckoutButton
            view={view}
            section={trackingKeys.menu}
            hideCounter
            isBasketComprehensionEnabled
          />
        </Box>
      </Box>
    </section>
  )
}
